export class Company {
  public id: number;
  public name: string;
  public host_code: string;
}



// WEBPACK FOOTER //
// ./src/app/models/company.model.ts